export enum LegalPolicyTypes {
  Privacy = 'privacy-policy',
  TermsOfService = 'terms-of-service'
}
